import React from "react";
import "./userMenu.css";

import { AnimatePresence, motion } from "framer-motion";
import { useAuth } from "../../../../contexts/AuthContext";

import { Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faArrowRightFromBracket,
  faArrowRightToBracket,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";

export default function UserMenu({ isOpen }) {
  const { currentUser, logout } = useAuth();

  const handleLogout = () => logout();

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.nav
          className={`user-popup-menu ${currentUser ? "" : "unauth-mode"}`}
          key="user-menu"
          initial={{
            borderRadius: "50%",
            height: "50px",
            width: "50px",
            bottom: "-150px",
            opacity: 1,
          }}
          animate={{
            bottom: [null, "calc(100% + 25px)"],
            width: [null, "120px"],
            height: [null, "90px"],
            borderRadius: [null, "5px"],
            opacity: 1,
          }}
          transition={{
            duration: 0.4,
          }}
          exit={{
            opacity: 0,
            transition: {
              duration: 0.3,
            },
          }}
        >
          <motion.ul
            key="user-menu-key"
            className="user-menu-list"
            initial={{
              opacity: 0,
            }}
            animate={{
              opacity: 1,
              transition: {
                duration: 0.3,
                delay: 0.4,
              },
            }}
            exit={{
              opacity: 0,
            }}
          >
            {currentUser ? (
              <>
                <li className="user-menu-item">
                  <Link to="/dashboard/" className="user-menu-item-link">
                    <FontAwesomeIcon icon={faUser} />
                    داشبورد
                  </Link>
                </li>
                <li className="user-menu-item" onClick={handleLogout}>
                  <Link to="/" className="user-menu-item-link">
                    <FontAwesomeIcon icon={faArrowRightFromBracket} />
                    خروج
                  </Link>
                </li>
              </>
            ) : (
              <>
                <li className="user-menu-item">
                  <Link to="login" className="user-menu-item-link">
                    <FontAwesomeIcon
                      icon={faArrowRightToBracket}
                      style={{ marginTop: "2px" }}
                    />
                    ورود
                  </Link>
                </li>
                <li className="user-menu-item">
                  <Link to="signup" className="user-menu-item-link">
                    <FontAwesomeIcon icon={faPlus} />
                    ثبت نام
                  </Link>
                </li>
              </>
            )}
          </motion.ul>
        </motion.nav>
      )}
    </AnimatePresence>
  );
}
